import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=5f9b0b28&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=5f9b0b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9b0b28",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShimmerEffectMultiple: require('/workspace/components/ShimmerEffectMultiple.vue').default,RestaurantCard: require('/workspace/components/RestaurantCard.vue').default})
